import type { ListItemButtonProps } from '@mui/material';
import { Box, ListItemButton } from '@mui/material';

import type { ElementType } from 'react';
import { forwardRef } from 'react';

import { tss } from 'tss-react/mui';

export type Or2ListItemButtonProps<T extends ElementType = ElementType> =
  ListItemButtonProps<T> & {
    rounded?: boolean;
    secondaryAction?: React.ReactNode;
  };

export const useStyles = tss.create(() => {
  return {
    rounded: {
      borderRadius: '20px',
    },
  };
});

export const Or2ListItemButton = forwardRef<
  HTMLDivElement,
  Or2ListItemButtonProps<ElementType>
>(
  (
    {
      children,
      className,
      rounded,
      disableGutters = false,
      secondaryAction,
      ...other
    },
    ref,
  ) => {
    const { classes, cx } = useStyles();

    return (
      <ListItemButton
        ref={ref}
        className={cx(
          {
            [classes.rounded]: rounded,
          },
          className,
        )}
        disableGutters={disableGutters}
        {...other}
      >
        {children}
        {secondaryAction && (
          <Box
            sx={[
              {
                position: 'absolute',
                right: 16,
                top: '50%',
                transform: 'translateY(-50%)',
              },
              disableGutters && { right: 0 },
            ]}
          >
            {secondaryAction}
          </Box>
        )}
      </ListItemButton>
    );
  },
);

Or2ListItemButton.displayName = 'Or2ListItemButton';
